export default __webpack_public_path__ + "static/Metropolis-Medium-d8a3fb682eb2cd1bd0fd9ae2139031b6.woff2";